import angular from 'angular';
import { ResubmitFailedOrderModule } from './resubmit-failed-order/resubmit-failed-order.module';
import { FailedOrdersService } from './failed-orders.service';
import { failedOrdersListModule } from './failed-orders-list/failed-orders-list.module';
export var FailedOrdersModule = angular
    .module('FailedOrders', [
    failedOrdersListModule,
    ResubmitFailedOrderModule
])
    .service('FailedOrdersService', FailedOrdersService)
    .name;
//# sourceMappingURL=failed-orders.module.js.map